<template lang="pug">
  .modal.is-active
    .modal-background(@click='cerrarModal')
    .modal-content
      .box
        button.delete(aria-label="close" @click='cerrarModal')
        .columns.has-text-centered
          .column.is-12
            h2.title.is-size-3.is-capitalized Contacto
        .columns.has-text-centered
          .column.is-12
            h3.subtitle.is-size-4 Por favor no dude en contactarnos por cualquiera de los siguientes medios.
        .columns
          .column.is-12
            .container
              .columns
                .column.is-12
                  .card
                    .card-content
                      .columns.has-text-centered
                        .column.is-12
                          span.is-2.icon.is-size-4
                            i.fas.fa-map-marker-alt
                      .columns.has-text-centered
                        .column.is-12
                          p.has-text-center.is-size-4
                            |	Av. Constituyentes No. 1080, piso 5
                          p.has-text-center.is-size-4
                            |	Col. Lomas Altas, Miguel Hidalgo
                          p.has-text-center.is-size-4
                            |	C.P. 11950, Ciudad de México.
        .columns
          .column.is-6
            .card
              .card-content
                .columns.has-text-centered
                  .column.is-12
                    span.is-2.icon.is-size-5
                      i.fas.fa-envelope
                .columns.has-text-centered
                  .column.is-12
                    p.is-size-5 contacto@ducter.com.mx
          .column.is-6
            .card
              .card-content
                .columns.has-text-centered
                  .column.is-12
                    span.is-2.icon.is-size-5
                      i.fas.fa-phone
                .columns.has-text-centered
                  .column.is-12
                    p.is-size-5 559 140 0120
                    p.is-size-5 591 916 5373
                    p.is-size-5 783 837 5219
</template>

<script>
  export default {
    name: 'ModalContacto',
    methods: {
      cerrarModal () {
        this.$emit('padre:cerrar', 'close')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .card {
    height: 100%;
    border: 1px solid #808080;
  }
</style>


// WEBPACK FOOTER //
// src/components/landing_Componentes/ModalContacto.vue